var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconThumbUpXlWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16663 45.4998H10.8333V19.4998H2.16663V45.4998ZM49.8333 21.6665C49.8333 19.2832 47.8833 17.3332 45.5 17.3332H31.8283L33.8866 7.4315L33.9516 6.73817C33.9516 5.84984 33.5833 5.0265 32.9983 4.4415L30.7016 2.1665L16.445 16.4448C15.6433 17.2248 15.1666 18.3082 15.1666 19.4998V41.1665C15.1666 43.5498 17.1166 45.4998 19.5 45.4998H39C40.7983 45.4998 42.3366 44.4165 42.9866 42.8565L49.53 27.5815C49.725 27.0832 49.8333 26.5632 49.8333 25.9998V21.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbUpXlWhite);
export default __webpack_public_path__ + "static/media/icon-thumb_up-xl-white.21c5c33a92591f54c6c73ff413af4cea.svg";
export { ForwardRef as ReactComponent };